import { selectorFamily } from "recoil";
import { layerDefsAtomFamily } from "../layerDefsAtoms";

export const layerDefFillColorSelector = selectorFamily({
  key: "layer-fill-color-selector",
  get:
    (layerID) =>
    ({ get }) => {
      const { layer } = get(layerDefsAtomFamily(layerID));
      if (layer.type === "fill") {
        return layer?.paint["fill-color"];
      }
    },
  set:
    (layerID) =>
    ({ set }, newFillColor) => {
      set(layerDefsAtomFamily(layerID), (oldLayer) => {
        return {
          ...oldLayer,
          layer: applyLayerFillColor(oldLayer.layer, newFillColor),
          overLayers: oldLayer.overLayers?.map((ol) => {
            return applyLayerFillColor(ol, newFillColor)
          })
        };
      });
    },
});

const applyLayerFillColor = (layer, newFillColor) => {
  if (layer.type === 'fill') {
    return {
      ...layer,
      paint: {
        ...layer.paint,
        "fill-color": newFillColor,
      },
    }
  }

  return layer
}